<template>
  <div style="display:flex;flex-wrap:wrap">
    <div class="product" v-for="(item, index) in productList" :key="index">
      <img :src="item.photoUrls[0]" class="productImg" />
      <div class="textBox">
        <h2>{{ item.name }}</h2>
        <div class="text more" ref="more">占位</div>
        <div class="text" style="padding-bottom: 20px">
          <div
            :class="{ retract: item.status }"
            :style="{ 'max-height': item.status ? textHeight : '' }"
            ref="textContainer"
          >
            {{ item.introduction }}
          </div>
          <div class="statusBtn">
            <p v-if="item.status" @click="item.status = false">展开</p>
            <p v-if="item.status == false" @click="item.status = true">收起</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['productList'],
  data() {
    return {
      // 产品列表
      textHeight: null,
    };
  },
  mounted() {
    this.productList.forEach((ele, index) => {
      this.$set(
        this.productList,
        index,
        Object.assign({}, ele, { status: null })
      );
      setTimeout(() => {
        this.calculateText();
      }, 0);
    });
    window.onresize = () => {
      this.productList.forEach((ele, index) => {
        this.$set(
          this.productList,
          index,
          Object.assign({}, ele, { status: null })
        );
      });
      setTimeout(() => {
        this.calculateText();
      }, 0);
    };
  },
  methods: {
    // 产品介绍展开收起
    // 计算文字 显示展开 收起
    calculateText() {
      // 获取一行文字的height 计算当前文字比较列表文字
      let oneHeight = this.$refs.more.scrollHeight;
      let twoHeight = oneHeight * 2 || 40;
      this.textHeight = `${twoHeight}px`;
      let txtDom = this.$refs.textContainer;
      for (let i = 0; i < txtDom.length; i++) {
        let curHeight = txtDom[i].offsetHeight;
        if (curHeight > twoHeight) {
          this.$set(
            this.productList,
            i,
            Object.assign({}, this.productList[i], { status: true })
          );
        } else {
          this.$set(
            this.productList,
            i,
            Object.assign({}, this.productList[i], { status: null })
          );
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
// 企业产品
.product {
  width:50%;
  margin-bottom:25px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  color: #ffffff;
}
.productImg {
  width: 100px;
  height: 100px;
  margin-right: 10px;
}
.textBox {
  width:75%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 20px;
}

.text {
  position: relative;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 2px;
  color: #ffffff;
}

.retract {
  position: relative;
  overflow: hidden;
}

.retract:after {
  content: "...";
  position: absolute;
  bottom: 0;
  right: 2px;
  width: 25px;
  padding-left: 35px;
  background: linear-gradient(to right, transparent, #104853 45%);
}

.statusBtn {
  position: absolute;
  right: 0;
  bottom: 0px;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 2px;
  color: #ffad41;
  cursor: pointer;
}

.more {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 2px;
  color: #666666;
  visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/leftAside/digital_industry/companyInformation/menu4.vue